<template>
  <div class="children">
    <!-- 그룹 슬롯-->
    <slot
      name="internal"
      :node="treeItem"
      :depth="treeDepth"
      :toggle="onToggleClicked"
      :expanded="expanded"
    ></slot>
    <!-- 확장 상태인 경우 표시하는 하위 노드-->
    <div
      v-show="expanded"
      :class="expanded && containerClasses && containerClasses[treeDepth]"
    >
      <template v-for="child in children">
        <tree-node
          :key="'sub' + (child.manualId || -1)"
          :container-classes="containerClasses"
          :tree-item="child"
          :tree-depth="depthNext"
        >
          <template #start="{ depth }">
            <slot name="start" :depth="depth"></slot>
          </template>
          <template #internal="{ node, depth, expanded, toggle }">
            <slot
              name="internal"
              :node="node"
              :depth="depth"
              :expanded="expanded"
              :toggle="toggle"
            ></slot>
          </template>
          <template #leaf="{ node, depth }">
            <slot name="leaf" :node="node" :depth="depth"></slot>
          </template>
          <template #end="{ depth }">
            <slot name="end" :depth="depth"></slot>
          </template>
        </tree-node>
      </template>
    </div>
  </div>
</template>

<script>
import TreeBase from '@/views/newManual/TreeMenuSlot/TreeBase'

export default {
  name: 'TreeInternal',
  components: {
    TreeNode: () => import('@/views/newManual/TreeMenuSlot/TreeNode'),
  },

  extends: TreeBase,

  props: {
    containerClasses: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    onToggleClicked() {
      this.toggle()
    },
  },
}
</script>
<style>
/*parents랑 children의 css 를 적용하기위해 작성했습니다.*/
.children{
    width: 100%;
}

</style>